<template>
  <div
    class="slide-block text-heading"
    :style="{ backgroundColor: backgroundColor ? backgroundColor : '#161F6B', color: fontColor ? fontColor : '#FFFFFF', border: borderColor ? `1px solid ${borderColor}` : '`1px solid #161F6B'}"
  >
    <div class="error-parametros" v-if="!verificaParametrosUrl">Error en parametros!</div>
    <div v-else>
      <hooper v-if="device === 'mobile'" style="height: 40px; fill: white;">
        <slide class="slide-ind">
          <a :href="hrefurl" title="Dólar Balanz" target="_blank">
            <span class="b-titulo">Dólar Balanz</span>
            <span class="bold-b">{{ dolarbalanzpreciocompra | formatPrice }}</span>
            <span class="space">/</span>
            <span class="bold-b">{{ dolarbalanzprecioventa | formatPrice }}</span>
          </a>
        </slide>
        <slide class="slide-ind">
          <span class="b-titulo">Dólar B.Nación</span>
          <span
            class="bold-b"
            :style="{ color: fontColor}"
          >{{ cotizacionBnatipocomprador | formatPrice }}</span>
          <span class="space">/</span>
          <span class="bold-b">{{ cotizacionBnatipovendedor | formatPrice }}</span>
        </slide>
        <slide class="slide-ind">
          <span class="b-titulo">Merval</span>
          <span class="bold-b">{{ indice | formatPrice }}</span>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
      </hooper>

      <hooper v-if="device === 'desktop'" style="height: 40px; fill: white;">
        <slide class="slide-ind">
          <a :href="hrefurl" title="Dólar Balanz" target="_blank">
            <span class="b-titulo">Dólar Balanz</span>
            <span class="bold-b">{{ dolarbalanzpreciocompra | formatPrice }}</span>
            <span class="space">/</span>
            <span class="bold-b">{{ dolarbalanzprecioventa | formatPrice }}</span>
            <span class="plus">|</span>
          </a>
          <span class="b-titulo">Dólar B.Nación</span>
          <span class="bold-b">{{ cotizacionBnatipocomprador | formatPrice }}</span>
          <span class="space">/</span>
          <span class="bold-b">{{ cotizacionBnatipovendedor | formatPrice }}</span>
          <span class="plus">|</span>
          <span class="b-titulo">Merval</span>
          <span class="bold-b">{{ indice | formatPrice }}</span>
        </slide>
      </hooper>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";

export default {
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: "#161F6B"
    },

    borderColor: {
      type: String,
      required: false,
      default: "#161F6B"
    },

    fontColor: {
      type: String,
      required: false,
      default: "#FFFFFF"
    },

    utmSource: {
      type: String,
      required: false,
      default: null
    },

    utmMedium: {
      type: String,
      required: false,
      default: null
    },

    utmCampaign: {
      type: String,
      required: false,
      default: null
    },

    utmContent: {
      type: String,
      required: false,
      default: null
    }
  },

  components: {
    Hooper,
    Slide,
    HooperNavigation
  },

  data() {
    return {
      device: "desktop",
      base: "https://www.balanz.com/dolar-al-mejor-precio.html",
      hrefurl: "https://www.balanz.com/dolar-al-mejor-precio.html",
      indice: "0",
      dolarbalanzpreciocompra: "0",
      dolarbalanzprecioventa: "0",
      cotizacionBnatipovendedor: "0",
      cotizacionBnatipocomprador: "0"
    };
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.fetchEventsList();
    this.hrefurl = `${this.base}?utm_source=${this.utmSource}&utm_medium=${this.utmMedium}&utm_campaign=${this.utmCampaign}&utm_content=${this.utmContent}`;
    this.timer = setInterval(this.fetchEventsList, 5 * 60 * 1000);
  },

  computed: {
    verificaParametrosUrl() {
      if (
        !this.utmSource ||
        !this.utmMedium ||
        !this.utmCampaign ||
        !this.utmContent
      ) {
        return false;
      }

      return true;
    }
  },

  methods: {
    fetchEventsList() {
      fetch("https://widgets.balanz.com/api/dolarbna", {
        mode: "cors",
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "Access-Control-Allow-Origin": "*"
        }
      })
        .then(response => response.json())
        .then(response => {
          if (response) {
            this.list = [];
            this.cotizacionBnatipocomprador =
              response.cotizacionBna[1].tipocomprador;
            this.cotizacionBnatipovendedor =
              response.cotizacionBna[1].tipovendedor;
            this.indice = response.cotizacionIndice[0].mervalultimovalor;
          } else this.list = [["", "No disponible", ""]];
        });

      fetch("https://widgets.balanz.com/api/dolarBalanz", {
        mode: "cors",
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "Access-Control-Allow-Origin": "*"
        }
      })
        .then(response => response.json())
        .then(response => {
          if (response) {
            this.dolarbalanzpreciocompra =
              response.precioCompraVenta[0].preciocompra;

            this.dolarbalanzprecioventa =
              response.precioCompraVenta[0].precioventa;
          }
        });
    },

    handleResize() {
      if (window.innerWidth <= 960) {
        this.device = "mobile";
      } else {
        this.device = "desktop";
      }
    }
  },

  filters: {
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>


<style>
* {
  font-family: "Roboto", sans-serif;
}

.error-parametros {
  font-size: 1rem;
  margin-top: 13px;
}

.b-titulo {
  font-family: "Roboto", sans-serif;
  margin-right: 6px;
}
.text-heading {
  font-size: 10px;
  line-height: 10px;
}

a {
  text-decoration: none;
  color: inherit;
}

.space {
  padding: 0 6px;
}

.plus {
  padding: 0 15px;
}

.bold-b {
  font-size: 16px;
  font-weight: bold;
  color: inherit;
  opacity: 0.6;
}

.slide-ind {
  font-size: 16px;
  line-height: 16px;
  float: left;
  margin: 0;
  padding: 0;
  width: 200px;
}

.plus {
  color: inherit;
  opacity: 0.6;
}

.space {
  color: inherit;
  opacity: 0.6;
}

.slide-block {
  background-color: #efefef;
  height: 40px;
  width: 100%;
  display: block;
  text-align: center;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.list {
  overflow: hidden;
  position: relative;
  width: 100%;
  display: inline-block;
  right: 0;
  top: 0;
  background: red;
}

.item {
  display: block;
  white-space: nowrap;
  width: 100%;
  position: absolute;
  top: -999em;
  right: 0;
  text-align: right;
}

.white {
  color: #ffffff;
  margin-right: 10px;
}

.grey {
  color: #aeadb3;
}

.p {
  padding: 0 5px;
}

.mr {
  margin-right: 10px;
}

.arrow {
  height: 13px;
  padding: 0 5px;
  position: relative;
  top: 1px;
}

@media only screen and (max-width: 960px) {
  .white {
    color: #000;
  }
}

.hooper-slide {
  flex-shrink: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.hooper-progress {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background-color: #efefef;
}

.hooper-progress-inner {
  height: 100%;
  background-color: #4285f4;
  transition: 300ms;
}

.hooper-pagination {
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  display: flex;
  padding: 5px 10px;
}

.hooper-indicators {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.hooper-indicator:hover,
.hooper-indicator.is-active {
  background-color: #4285f4;
}

.hooper-indicator {
  margin: 0 2px;
  width: 12px;
  height: 4px;
  border-radius: 4px;
  border: none;
  padding: 0;
  background-color: #fff;
  cursor: pointer;
}

.hooper-pagination.is-vertical {
  bottom: auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.hooper-pagination.is-vertical .hooper-indicators {
  flex-direction: column;
}

.hooper-pagination.is-vertical .hooper-indicator {
  width: 6px;
}

.hooper-next,
.hooper-prev {
  fill: rgb(255, 255, 255);
  background-color: transparent;
  border: none;
  padding: 1em;
  position: absolute;
  top: 50%;
  padding-top: 6px;
  height: 40px;
  transform: translateY(-50%);
  cursor: pointer;
}

.hooper-next.is-disabled,
.hooper-prev.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.hooper-next {
  right: 0;
}

.hooper-prev {
  left: 0;
}

.hooper-navigation.is-vertical .hooper-next {
  top: auto;
  bottom: 0;
  transform: initial;
}

.hooper-navigation.is-vertical .hooper-prev {
  top: 0;
  bottom: auto;
  right: 0;
  left: auto;
  transform: initial;
}

.hooper-navigation.is-rtl .hooper-prev {
  left: auto;
  right: 0;
}

.hooper-navigation.is-rtl .hooper-next {
  right: auto;
  left: 0;
}

section {
  display: block;
}

ul {
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}

.hooper {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 200px;
}

.hooper * {
  box-sizing: border-box;
}

.hooper-list {
  overflow: hidden;
  width: 100%;
  height: 40px;
}

.hooper-track {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0;
  margin: 0;
}

.hooper.is-vertical .hooper-track {
  flex-direction: column;
  height: 200px;
}

.hooper.is-rtl {
  direction: rtl;
}

.hooper-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.slide-block {
  background-color: #efefef;
  height: 40px;
  width: 100%;
  display: block;
  text-align: center;
}

.slide-ind {
  font-size: 16px;
  line-height: 16px;
  padding-top: 12px;
  float: left;
  margin: 0;
}

.space {
  padding: 0 6px;
}

.plus {
  padding: 0 15px;
}
</style>
